// import Helpers from '../modules/helpers';
import $ from 'jquery';

const ScrollTo = {
    bindEvents: () => {
        const scrollPoints = document.getElementsByClassName('button-scrollto');
        if (scrollPoints[0]) {
            ScrollTo.init();
        }
    },

    init: () => {
        const scrollPoints = document.getElementsByClassName('button-scrollto');
        for (var i = 0; i < scrollPoints.length; i++) {
            scrollPoints[i].addEventListener("click", function () {

                let scrollY = $('[data-scroll="'+ this.id +'"]').offset().top;

                $('html, body').animate({
                    scrollTop: scrollY - 120
                }, 800, function(){});

            });
        }

    }
};

module.exports = ScrollTo;



// WEBPACK FOOTER //
// ./src/js/partials/scrollto.js